import React from 'react';
import { Link } from 'react-router-dom';

/** Wymagana zgoda na Regulamin / UGC (`acceptUgcTerms` w API). */
export default function UgcTermsCheckbox({
  checked,
  onChange,
  onShowTerms,
  onShowPrivacy,
  className = '',
  hint,
}) {
  return (
    <div className={`ugc-terms ${className}`.trim()}>
      <label className="ugc-terms-row">
        <input
          type="checkbox"
          className="ugc-terms-input"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className={`ugc-terms-box ${checked ? 'ugc-terms-box--on' : ''}`} aria-hidden>
          {checked && <span className="material-icons ugc-terms-check">check</span>}
        </span>
        <span className="ugc-terms-text">
          Akceptuję{' '}
          {onShowTerms ? (
            <button type="button" className="link-btn" onClick={onShowTerms}>Regulamin</button>
          ) : (
            <Link to="/terms" className="link-btn" target="_blank" rel="noopener noreferrer">Regulamin</Link>
          )}
          {' '}oraz{' '}
          {onShowPrivacy ? (
            <button type="button" className="link-btn" onClick={onShowPrivacy}>Politykę prywatności</button>
          ) : (
            <Link to="/privacy" className="link-btn" target="_blank" rel="noopener noreferrer">Politykę prywatności</Link>
          )}
          {' '}VROOM. W społeczności obowiązuje{' '}
          <strong>zerowa tolerancja</strong> dla treści obraźliwych, wulgarnych i nękających.
        </span>
      </label>
      {hint && !checked && <p className="ugc-terms-hint">{hint}</p>}
    </div>
  );
}

